import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
import NotificationAlert from 'componentes/generic/Notification.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
const URI = ApiEndpoint + 'administration/';
const URIConfig = ApiEndpoint + 'configuration/';
const EditDelegacionProfeco = ({ idDelegacionProfeco, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);
  const [municipios, setMunicipios] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);
  const [selectedMunicipioDescription, setSelectedMunicipioDescription] =
    useState(null);

  const [delegacionProfeco, setDelegacionProfeco] = useState({
    nombre: '',
    comentarios: '',
    idmunicipio: 0
  });
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URIConfig + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getMunicipiosList = async idState => {
    setMunicipios(null);

    httpClient('GET', URIConfig + 'cities/' + idState, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getDelegacionProfeco = async () => {
    setDelegacionProfeco(null);

    httpClient(
      'GET',
      URI + 'delegation/' + idDelegacionProfeco,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setSelectedEstado(response.data.municipio.idestado);
          setSelectedMunicipioDescription(response.data.municipio.descripcion);

          setValue('nombre', response.data.nombre);
          setValue('comentarios', response.data.comentarios);
          setValue('idmunicipio', response.data.idmunicipio);
          setValue('estado', response.data.municipio.idestado);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (idDelegacionProfeco > 0) getDelegacionProfeco();
    getStatesList();
  }, []);

  useEffect(() => {
    if (selectedEstado > 0) getMunicipiosList(selectedEstado);
  }, [selectedEstado]);

  const onSubmit = data => {
    console.log(data);

    if (idDelegacionProfeco > 0) {
      httpClient(
        'put',
        URI + 'delegation/' + idDelegacionProfeco,
        {
          nombre: data.nombre,
          comentarios: data.comentarios,
          idmunicipio: data.idmunicipio.id,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'delegation',
        {
          nombre: data.nombre,
          comentarios: data.comentarios,
          idmunicipio: data.idmunicipio.id,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Nombre</Form.Label>
                  <FormControl
                    {...register('nombre', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={delegacionProfeco?.nombre}
                    isInvalid={!!errors.nombre}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.nombre?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Estado</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idestado"
                    id="idestado"
                    className="form-control"
                    {...register('estado', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('estado', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedEstado(e.target.value);
                      getMunicipiosList(e.target.value);
                    }}
                    value={`${selectedEstado}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un estado
                    </option>
                    {!!states?.length &&
                      states.map(estado => (
                        <option key={estado.idestado} value={estado.idestado}>
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.estado?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                {municipios && (
                  <AutocompleteDropdown
                    items={
                      !municipios
                        ? []
                        : municipios.map(municipio => {
                            return {
                              id: municipio.idmunicipio,
                              description: municipio.descripcion
                            };
                          })
                    }
                    register={register}
                    errors={errors}
                    name="idmunicipio"
                    placeholder="Selecciona un municipio"
                    currentSelected={selectedMunicipioDescription}
                    setCurrentSelected={value => {
                      setValue('idmunicipio', value, { shouldValidate: true });
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Comentarios</Form.Label>
                  <FormControl
                    {...register('comentarios', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={delegacionProfeco?.comentarios}
                    isInvalid={!!errors.comentarios}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.comentarios?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditDelegacionProfeco.propTypes = {
  idDelegacionProfeco: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EditDelegacionProfeco;
